import { render, staticRenderFns } from "./Ecosystem.vue?vue&type=template&id=5e9fc27a&scoped=true"
import script from "./Ecosystem.vue?vue&type=script&lang=js"
export * from "./Ecosystem.vue?vue&type=script&lang=js"
import style0 from "./Ecosystem.vue?vue&type=style&index=0&id=5e9fc27a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9fc27a",
  null
  
)

export default component.exports